import { forwardRef, useImperativeHandle, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import { ReactComponent as HomeSvgIcon } from '../../../image/Home.svg';
import { ReactComponent as MemberSvgIcon } from '../../../image/Member.svg';
import { ReactComponent as ClassSvgIcon } from '../../../image/Class.svg';
import { ReactComponent as ChartSvgIcon } from '../../../image/Chart.svg';
import { ReactComponent as LockerSvgIcon } from '../../../image/Locker.svg';
import { ReactComponent as BoardSvgIcon } from '../../../image/Board.svg';
import { ReactComponent as NoteSvgIcon } from '../../../image/Note.svg';
import { ReactComponent as NoticeSvgIcon } from '../../../image/Notice.svg';
import { ReactComponent as SettingSvgIcon } from '../../../image/Setting.svg';
import { ReactComponent as AiSvgIcon } from '../../../image/Ai.svg';

import FetchModule from '../Network/FetchModule';

// 부계정(SUB) navItems 코드 → 기존 nav id 매핑 (서버 주도 네비, setting 제외) //
const SUB_NAV_CODE_TO_ID = {
  AI: 'ai',
  HOME: 'home',
  MEMBER: 'member',
  CLASS: 'class',
  STATS: 'statistics',
  LOCKER: 'locker',
  BOARD: 'board',
  NOTE: 'note',
  NOTICE: 'notice'
};

const NavigationBar = forwardRef((props, ref) => {
  const { nowPage, setNowPage } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, isEng } = useLanguage();

  const defaultURL = 'https://link-zone.io';

  const history = useHistory();
  const [index, setIndex] = useState(0);
  const [nowPageKey, setNowPageKey] = useState('home');
  const [isExistPartnerGym, setIsExistPartnerGym] = useState(false);
  const [registrationCount, setRegistrationCount] = useState(0);

  let location = useLocation();

  useImperativeHandle(ref, () => ({
  }));

  let NavInfo = [{
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledHomeSvg,
    id: 'home',
    text: t('nav.home'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/main'],
  },
  // {
  //   buttonRef: useRef(),
  //   isSvg: true,
  //   svgRef: useRef(),
  //   SvgComponent: StyledAiSvg,
  //   id: 'ai',
  //   text: "AI",
  //   imgRef: useRef(),
  //   imgHoverRef: useRef(),
  //   imgClickRef: useRef(),
  //   textRef: useRef(),
  //   subRef: useRef(),
  //   children: [],
  //   destination: ['/ai'],
  // },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledMemberSvg,
    id: 'member',
    text: t('nav.member'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [{
      btnRef: useRef(),
      subId: 'valid',
      subText: t('nav.validMember')
    },
    {
      btnRef: useRef(),
      subId: 'expired',
      subText: t('nav.expiredMember')
    },
    {
      btnRef: useRef(),
      subId: 'registration',
      subText: t('nav.memberRegistration')
    },
    {
      btnRef: useRef(),
      subId: 'payment',
      subText: t('nav.paymentApproval')
    },
    {
      btnRef: useRef(),
      subId: 'partner',
      subText: t('nav.partnerMember')
    }
    ],
    destination: ['/member/valid', '/member/expired', '/member/registration', '/member/waitting', '/member/partner_gym'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledClassSvg,
    id: 'class',
    text: t('nav.class'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/class'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledChartSvg,
    id: 'statistics',
    text: t('nav.statistics'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/statistics'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledLockerSvg,
    id: 'locker',
    text: t('nav.locker'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/locker'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledBoardSvg,
    id: 'board',
    text: t('nav.board'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/board'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledNoteSvg,
    id: 'note',
    text: t('nav.note'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/note/program'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledNoticeSvg,
    id: 'notice',
    text: t('nav.notice'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [{
      btnRef: useRef(),
      subId: 'writeNotice',
      subText: t('nav.writeNotice')
    },
    {
      btnRef: useRef(),
      subId: 'sendMessage',
      subText: t('nav.sendMessage')
    }],
    destination: ['/notice', '/message'],
  },
  {
    buttonRef: useRef(),
    isSvg: true,
    svgRef: useRef(),
    SvgComponent: StyledSettingSvg,
    id: 'setting',
    text: t('nav.setting'),
    imgRef: useRef(),
    imgHoverRef: useRef(),
    imgClickRef: useRef(),
    textRef: useRef(),
    subRef: useRef(),
    children: [],
    destination: ['/setting'],
  }]

  // navItems 코드 (MAIN/SUB 공통) — SUB 메뉴 필터 + MAIN AI 게이트 //
  let navCodes = [];

  try {
    const storedNavItems = window.sessionStorage.getItem('NavItems');
    navCodes = storedNavItems ? JSON.parse(storedNavItems) : [];
  }
  catch (e) {
    navCodes = [];
  }

  const accountType = window.sessionStorage.getItem('AccountType');

  if (accountType === 'SUB') {
    // SUB: navItems 코드에 매핑된 메뉴만 노출 (이제 AI 포함) //
    const allowedNavIds = new Set(navCodes.map(code => SUB_NAV_CODE_TO_ID[code]).filter(Boolean));

    for (const item of NavInfo) {
      item.hidden = !allowedNavIds.has(item.id);
    }
  }
  else if (navCodes.length > 0) {
    // MAIN: AI 항목만 navItems 의 'AI' 포함 여부로 게이트 (나머지 정적 유지, navCodes 없으면 구백엔드/레거시 → 기존 노출) //
    const aiItem = NavInfo.find(item => item.id === 'ai');

    if (aiItem) aiItem.hidden = !navCodes.includes('AI');
  }

  // 가장 긴 텍스트 길이에 따라 margin-left 동적 계산 (어떤 언어가 추가되어도 자동 대응)
  // const maxTextLength = Math.max(...NavInfo.filter(d => !d.hidden).map(d => d.text.length));
  // const iconMarginLeft = Math.max(4, 16 - (maxTextLength - 2) * 2);
  const iconMarginLeft = isEng ? 12 : 16;

  useEffect(() => {
    let path = location.pathname;

    if (path === '/main') {
      setNowPageKey('home');
      setIndex(0);
    }
    // else if (path === '/ai') {
    //   setNowPageKey('ai');
    //   setIndex(1);
    // }
    else if (path.includes('/member/valid')
      || path.includes('/member/expired')
      || path.includes('/member/registration')
      || path.includes('/member/waitting')
      || path.includes('/member/partner_gym')) {
      setNowPageKey('member');
      setIndex(1);
    }
    else if (path.includes('/class')) {
      setNowPageKey('class');
      setIndex(2);
    }
    else if (path.includes('/statistics')) {
      setNowPageKey('statistics');
      setIndex(3);
    }
    else if (path.includes('/locker')) {
      setNowPageKey('locker');
      setIndex(4);
    }
    else if (path.includes('/board')) {
      setNowPageKey('board');
      setIndex(5);
    }
    else if (path.includes('/notice')
      || path.includes('/message')) {
      setNowPageKey('notice');
      setIndex(7);
    }
    else if (path.includes('/setting')) {
      setNowPageKey('setting');
      setIndex(8);
    }

    setNowPage(defaultURL + location.pathname);
  }, [location])

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/registration/count', 'GET');

        if (responseData.status === 200) {
          setIsExistPartnerGym(responseData.data.isExistPartnerGym);
          setRegistrationCount(responseData.data.memberCount + responseData.data.productCount);
        }
      }
    )();
  }, [location])

  useEffect(() => {
    if (nowPage === defaultURL + '/'
      || nowPage.includes(defaultURL + '/certification')
      || nowPage.includes(defaultURL + '/identifier')
      || nowPage.includes(defaultURL + '/permute')
      || nowPage.includes(defaultURL + '/rule/')
      || nowPage.includes(defaultURL + '/full/board/')
      || nowPage.includes(defaultURL + '/full/board-test/')
      || nowPage.includes(defaultURL + '/payment')
      || nowPage === defaultURL + '/mypage'
      || nowPage.includes(defaultURL + '/find-id')
      || nowPage.includes(defaultURL + '/keypad')
      || nowPage.includes(defaultURL + '/app')
      || nowPage.endsWith('/ai')) return;

    for (let i = 0; i < NavInfo.length; i++) {
      if (!NavInfo[i].buttonRef.current) continue;

      if (index !== i) {
        NavInfo[i].svgRef.current.style.color = theme.line;
        NavInfo[i].textRef.current.style.color = theme.line;
        NavInfo[i].buttonRef.current.style.backgroundColor = theme.background;
      }
    }

    if (!NavInfo[index].buttonRef.current) return;

    NavInfo[index].svgRef.current.style.color = theme.background;
    NavInfo[index].textRef.current.style.color = theme.background;
    NavInfo[index].clicked = true;
    NavInfo[index].buttonRef.current.style.backgroundColor = theme.primary;

    if (NavInfo[index].id === 'member') {
      if (isExistPartnerGym) NavInfo[index].subRef.current.style.height = `240px`;

      else NavInfo[index].subRef.current.style.height = `192px`;
    }
    else if (NavInfo[index].id === 'notice') NavInfo[index].subRef.current.style.height = `96px`;
  }, [index, nowPage, isExistPartnerGym, isDark])

  if (nowPage === defaultURL + '/'
    || nowPage.includes(defaultURL + '/certification')
    || nowPage.includes(defaultURL + '/identifier')
    || nowPage.includes(defaultURL + '/permute')
    || nowPage.includes(defaultURL + '/rule/')
    || nowPage.includes(defaultURL + '/full/board/')
    || nowPage.includes(defaultURL + '/full/board-test/')
    || nowPage.includes(defaultURL + '/payment')
    || nowPage === defaultURL + '/mypage'
    || nowPage.includes(defaultURL + '/find-id')
    || nowPage.includes(defaultURL + '/keypad')
    || nowPage.includes(defaultURL + '/app')
    || nowPage.endsWith('/ai')) return null;


  function clickButton(index) {
    setNowPageKey(NavInfo[index].id);
    setIndex(index);

    history.push(NavInfo[index].destination[0]);
  }

  function focusButton(innerIndex) {
    if (index === innerIndex) return;

    NavInfo[innerIndex].svgRef.current.style.color = theme.primary;
    NavInfo[innerIndex].textRef.current.style.color = theme.primary;
  }

  function blurButton(innerIndex) {
    if (index === innerIndex) return;

    NavInfo[innerIndex].svgRef.current.style.color = theme.line;
    NavInfo[innerIndex].textRef.current.style.color = theme.line;
  }

  function clickSubButton(index, idx) {

    if (NavInfo[index].destination[idx] === '/member/valid') {
      window.localStorage.removeItem('ValidMemberMembershipNames');
      window.localStorage.removeItem('ValidMemberGenderSort');
      window.localStorage.removeItem('ValidMemberBirthSort');
      window.localStorage.removeItem('ValidMemberStartSort');
      window.localStorage.removeItem('ValidMemberEndSort');
      window.localStorage.removeItem('ValidMemberClassSort');
      window.localStorage.removeItem('ValidMemberDivision');
      window.localStorage.removeItem('ValidMemberPage');
    }
    else if (NavInfo[index].destination[idx] === '/member/expired') {
      window.localStorage.removeItem('InvalidMemberMembershipNames');
      window.localStorage.removeItem('InvalidMemberGenderSort');
      window.localStorage.removeItem('InvalidMemberBirthSort');
      window.localStorage.removeItem('InvalidMemberStartSort');
      window.localStorage.removeItem('InvalidMemberEndSort');
      window.localStorage.removeItem('InvalidMemberClassSort');
      window.localStorage.removeItem('InvalidMemberPage');
    }

    history.push(NavInfo[index].destination[idx]);
  }

  // 파트너 회원을 포함한 소주제 표출여부 결정 //
  function decideViewSubMapComponent(data) {
    if (data.subId === 'partner') {
      if (isExistPartnerGym) return true;
      else return false;
    }
    else return true;
  }

  return (
      <TopLevelWrapper>
        {
          NavInfo.map((data, mapIndex) => !data.hidden && (
            <TotalWrapper key={'Nav-' + mapIndex}>
              {
                index === mapIndex ?
                  <ActiveButton ref={data.buttonRef} onClick={() => clickButton(mapIndex)}>
                    <ImageBox marginLeft={iconMarginLeft} isEng={isEng}>
                      <data.SvgComponent ref={data.svgRef} />
                    </ImageBox>
                    <ButtonTextWrapper>
                      <ActiveButtonText ref={data.textRef} isEng={isEng}>{data.text}</ActiveButtonText>
                    </ButtonTextWrapper>
                  </ActiveButton>
                  :
                  <InactiveButton ref={data.buttonRef} onClick={() => clickButton(mapIndex)} onMouseOver={() => focusButton(mapIndex)} onMouseLeave={() => blurButton(mapIndex)}>
                    <ImageBox marginLeft={iconMarginLeft} isEng={isEng}>
                      <data.SvgComponent ref={data.svgRef} />
                    </ImageBox>
                    <ButtonTextWrapper>
                      <ButtonText ref={data.textRef} isEng={isEng}>{data.text}</ButtonText>
                    </ButtonTextWrapper>
                  </InactiveButton>
              }
              {data.children.length !== 0 && data.id === nowPageKey ?
                <SubButtonWrapper ref={data.subRef}>
                  {
                    data.children.map((childData, idx) => (
                      <SubWrapper>
                        {
                          (nowPageKey === 'member' && data.id === 'member' && idx === 3 && registrationCount > 0) &&
                          <CountComponent style={{ marginRight: '-8px' }}>
                            <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Bold' fontSize={12} color={theme.white} cursor='default'>{registrationCount}</Text>
                          </CountComponent>
                        }
                        {
                          decideViewSubMapComponent(childData) &&
                          (nowPage.includes(defaultURL + data.destination[idx]) ?
                            <ActiveSubButton key={idx} ref={childData.btnRef} onClick={() => clickSubButton(mapIndex, idx)}>
                              {childData.subText}
                            </ActiveSubButton>
                            :
                            <InactiveSubButton key={idx} ref={childData.btnRef} onClick={() => clickSubButton(mapIndex, idx)}>
                              {childData.subText}
                            </InactiveSubButton>
                          )
                        }
                      </SubWrapper>
                    ))
                  }
                </SubButtonWrapper>
                :
                null
              }
            </TotalWrapper>
          ))
        }
      </TopLevelWrapper>
  )
})

export default NavigationBar;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 120px;

  padding: 0 10px;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;
`;

const CountComponent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -12px;

  width: 24px;
  height: 24px;

  border-radius: 24px;
  background-color: ${props => props.theme.pointRed};

  &:hover {
    cursor: default;
  }
`;

const InactiveButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 120px;
  height: 48px;

  border-radius: 30px;

  margin-bottom: 8px;

  background-color: ${props => props.theme.background};

  transition: background-color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const ActiveButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 120px;
  height: 48px;

  border-radius: 30px;

  margin-bottom: 8px;

  background-color: ${props => props.theme.primary};

  & svg {
    color: ${props => props.theme.background};
    transition: none;
  }

  &:hover {
    cursor: pointer;
  }
`;

const ImageBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-left: ${props => props.marginLeft}px;
  margin-right: ${props => props.isEng ? '0px' : '12px'};

  width: 24px;
  height: 24px;

  flex-shrink: 0;

  &:hover {
    cursor: pointer;
  }
`;

const StyledHomeSvg = styled(HomeSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledMemberSvg = styled(MemberSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledClassSvg = styled(ClassSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledChartSvg = styled(ChartSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledLockerSvg = styled(LockerSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledBoardSvg = styled(BoardSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledNoteSvg = styled(NoteSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledNoticeSvg = styled(NoticeSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledSettingSvg = styled(SettingSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const StyledAiSvg = styled(AiSvgIcon)`
  width: 21px;
  height: auto;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;
`;

const ButtonTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  flex: 1;
  height: 26px;

  overflow: hidden;
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isEng ? 16 : 18}px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;

  flex: 1;
  text-align: center;

  &:hover {
    cursor: pointer;
  }

  transition: color 0.3s ease-in-out;
`;

const ActiveButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isEng ? 16 : 18}px;

  color: ${props => props.theme.background};

  margin: 0 0 0 0;

  flex: 1;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

const SubButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-bottom: 10px;

  width: 120px;
  height: 0px;

  border-radius: 24px;

  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 100%;
  height: 48px;
`;

const InactiveSubButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 120px;
  height: 48px;

  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.line};

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.primary};
  }
`;

const ActiveSubButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 120px;
  height: 48px;

  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;
